import { fromNow } from './dateUtils'

export interface FamilyMember {
  name: string
  description: string
  vaccinatedAt: string
  id: number
  vaccines?: number
}

export const calculateNextVaccinationDate = (date: string) => {
  // Add 90 days to first vaccination date
  const dateString = date.replace(/(\d+[/])(\d+[/])/, '$2$1')
  const currentDate = new Date(dateString)
  currentDate.setDate(currentDate.getDate() + 90)
  return (
    'Segunda dose ' +
    fromNow(currentDate) +
    ` (${currentDate.toLocaleDateString('pt-br')})`
  )
}

export interface Family {
  name: string
  id: number
  members: FamilyMember[]
  membersCount?: number
  vaccinatedCount?: number
}

const families: Family[] = [
  {
    name: 'Familia Valdilene',
    id: 0,
    members: [
      {
        name: 'Valdilene',
        description: '',
        vaccinatedAt: '09/06/2021',
        vaccines: 1,
        id: 0,
      },
      {
        name: 'Joao',
        description: '',
        vaccinatedAt: '16/05/2021',
        vaccines: 2,
        id: 1,
      },
      {
        name: 'Janna',
        description: '',
        vaccinatedAt: '02/06/2021',
        vaccines: 2,
        id: 1,
      },
      {
        name: 'Yann',
        description: 'Segunda dose ' + fromNow('07/25/2021') + ' (25/07/2021)',
        vaccinatedAt: '20/06/2021',
        vaccines: 1,
        id: 1,
      },
      {
        id: 1,
        name: 'Camila',
        description: '',
        vaccinatedAt: '20/07/2021',
        vaccines: 2,
      },
    ],
  },
  {
    name: 'Familia Silene',
    id: 0,
    members: [
      {
        name: 'Silene',
        description: '',
        vaccinatedAt: '17/04/2021',
        vaccines: 2,
        id: 0,
      },
      {
        name: 'Jaina',
        description: '',
        vaccinatedAt: '03/06/2021',
        vaccines: 1,
        id: 1,
      },
      {
        name: 'Wagner',
        description: '',
        vaccinatedAt: '15/06/2021',
        vaccines: 1,
        id: 1,
      },
      {
        name: 'Jean',
        description: '',
        vaccinatedAt: '26/06/2021',
        vaccines: 1,
        id: 1,
      },
      {
        name: 'Dayse',
        description: '',
        vaccinatedAt: '20/02/2021',
        vaccines: 2,
        id: 1,
      },
      {
        name: 'Jane',
        description: ' ',
        vaccinatedAt: '-',
        vaccines: 1,
        id: 1,
      },
      {
        name: 'Mourão',
        description: ' ',
        vaccinatedAt: '-',
        vaccines: 1,
        id: 1,
      },
    ],
  },
  {
    name: 'Familia Deny',
    id: 0,
    members: [
      {
        name: 'Deny',
        description: '',
        vaccinatedAt: '08/05/2021',
        vaccines: 2,
        id: 0,
      },
      {
        name: 'Castro',
        description: '',
        vaccinatedAt: '24/04/2021',
        vaccines: 2,
        id: 0,
      },
      {
        name: 'Douglas',
        description: '',
        vaccinatedAt: '04/06/2021',
        vaccines: 1,
        id: 0,
      },
    ],
  },
  {
    name: 'Familia Zulene',
    id: 0,
    members: [
      {
        name: 'Zulene',
        description: '',
        vaccinatedAt: '08/05/2021',
        vaccines: 2,
        id: 0,
      },
      {
        name: 'Nonato',
        description: '',
        vaccinatedAt: '',
        vaccines: 2,
        id: 0,
      },
      {
        name: 'Nonato Filho',
        description: '',
        vaccinatedAt: '03/06/2021',
        vaccines: 1,
        id: 0,
      },
      {
        name: 'Maira',
        description: ' ',
        vaccinatedAt: '',
        vaccines: 1,
        id: 0,
      },
      {
        name: 'Felipe',
        description: '',
        vaccinatedAt: '27/01/2021',
        vaccines: 2,
        id: 0,
      },
      {
        name: 'Talita',
        description: '',
        vaccinatedAt: '-',
        vaccines: 2,
        id: 0,
      },
      {
        name: 'Werbster',
        description: ' ',
        vaccinatedAt: '',
        vaccines: 1,
        id: 0,
      },
      {
        name: 'Rafaela',
        description: ' ',
        vaccinatedAt: '',
        vaccines: 1,
        id: 0,
      },
      {
        name: 'Natercia',
        description: '',
        vaccinatedAt: '08/05/2021',
        vaccines: 1,
        id: 0,
      },
    ],
  },
  {
    name: 'Familia Valdir',
    id: 0,
    members: [
      {
        name: 'Valdir',
        description: ' ',
        vaccinatedAt: '',
        vaccines: 1,
        id: 0,
      },
      {
        name: 'Socorro',
        description: '',
        vaccinatedAt: '22/06/2021',
        vaccines: 2,
        id: 0,
      },
      {
        name: 'Tayanny',
        description: '',
        vaccinatedAt: '-',
        vaccines: 2,
        id: 0,
      },
      {
        name: 'Layanny',
        description: '',
        vaccinatedAt: '28/01/2021',
        vaccines: 2,
        id: 0,
      },
      {
        name: 'Welkson',
        description: '',
        vaccinatedAt: '',
        vaccines: 0,
        id: 0,
      },
    ],
  },
  {
    name: 'Familia José Olivar',
    id: 0,
    members: [
      {
        name: 'Fatima',
        description: '',
        vaccinatedAt: '05/05/2021',
        vaccines: 2,
        id: 0,
      },
      {
        name: 'Jose Olivar',
        description: '',
        vaccinatedAt: '17/04/2021',
        vaccines: 2,
        id: 0,
      },
      {
        name: 'Galdino neto',
        description: '',
        vaccinatedAt: '02/06/2021',
        vaccines: 1,
        id: 0,
      },
      {
        name: 'Adalgisa',
        description: '',
        vaccinatedAt: '26/06/2021',
        vaccines: 1,
        id: 0,
      },
      {
        name: 'Fabiana',
        description: '',
        vaccinatedAt: '04/06/2021',
        vaccines: 1,
        id: 0,
      },
      {
        name: 'Aldir',
        description: '',
        vaccinatedAt: '20/06/2021',
        vaccines: 1,
        id: 0,
      },
    ],
  },
  {
    name: 'Familia Francisco',
    id: 0,
    members: [
      {
        name: 'Francisco',
        description: '',
        vaccinatedAt: '23/03/2021',
        vaccines: 2,
        id: 0,
      },
      {
        name: 'Onelia',
        description: '',
        vaccinatedAt: '-',
        vaccines: 2,
        id: 0,
      },
      {
        name: 'Rodrigo',
        description: '',
        vaccinatedAt: '29/05/2021',
        vaccines: 1,
        id: 0,
      },
      {
        name: 'Ana Laura',
        description: '',
        vaccinatedAt: '-',
        vaccines: 2,
        id: 0,
      },
    ],
  },
  {
    name: 'Familia Narciso',
    id: 0,
    members: [
      {
        name: 'Narciso',
        description: '',
        vaccinatedAt: '21/05/2021',
        vaccines: 2,
        id: 0,
      },
      {
        name: 'Tania',
        description: ' ',
        vaccinatedAt: '',
        vaccines: 1,
        id: 0,
      },
      {
        name: 'Naiara',
        description: '',
        vaccinatedAt: '29/05/2021',
        vaccines: 1,
        id: 0,
      },
      {
        name: 'Bruno',
        description: '',
        vaccinatedAt: '29/05/2021',
        vaccines: 1,
        id: 0,
      },
      {
        name: 'Rayane',
        description: '',
        vaccinatedAt: '',
        vaccines: 0,
        id: 0,
      },
    ],
  },
  {
    name: 'Familia Socorro',
    id: 0,
    members: [
      {
        name: 'Socorro',
        description: '',
        vaccinatedAt: '12/04/2021',
        vaccines: 2,
        id: 0,
      },
      {
        name: 'Girleive',
        description: '',
        vaccinatedAt: '10/06/2021',
        vaccines: 1,
        id: 0,
      },
      {
        name: 'Ronaldo',
        description: '',
        vaccinatedAt: '-',
        vaccines: 2,
        id: 0,
      },
      {
        name: 'Isaias',
        description: '',
        vaccinatedAt: '',
        vaccines: 0,
        id: 0,
      },
      {
        name: 'Davi',
        description: '',
        vaccinatedAt: '',
        vaccines: 0,
        id: 0,
      },
      {
        name: 'Girlandia',
        description: '',
        vaccinatedAt: '02/06/2021',
        vaccines: 1,
        id: 0,
      },
      {
        name: 'Fabio',
        description: '',
        vaccinatedAt: '29/05/2021',
        vaccines: 1,
        id: 0,
      },
      {
        name: 'Rosemeire',
        description: '',
        vaccinatedAt: '03/06/2021',
        vaccines: 1,
        id: 0,
      },
    ],
  },
  {
    name: 'Familia Lucilene',
    id: 0,
    members: [
      {
        name: 'Lucilene',
        description: '',
        vaccinatedAt: '10/07/2021',
        vaccines: 2,
        id: 0,
      },
      {
        name: 'Everton',
        description: '',
        vaccinatedAt: '',
        vaccines: 0,
        id: 0,
      },
      {
        name: 'Tetsuyara',
        description: '',
        vaccinatedAt: '',
        vaccines: 0,
        id: 0,
      },
    ],
  },
].sort((a, b) => (a.name < b.name ? -1 : 1))
export const getFamilyMeta = () => {
  return families.reduce(
    (acc, family) => {
      acc.vaccinatedCount =
        acc.vaccinatedCount +
        family.members.filter(
          (member) => typeof member.vaccines === 'number' && member.vaccines > 0
        ).length
      acc.membersCount = acc.membersCount + family.members.length

      return acc
    },
    { membersCount: 0, vaccinatedCount: 0 }
  )
}
export const getFamily = (query: string, isFiltered: boolean) =>
  families.map((family) => {
    const members = family.members.filter((member) => {
      let isMatch = true

      if (query) {
        isMatch = member.name.toLowerCase().includes(query.toLowerCase())
      }

      if (isFiltered) {
        isMatch = isMatch && !!member.vaccinatedAt
      }

      return isMatch
    })

    return {
      name: family.name,
      members,
      vaccinatedCount: family.members.filter((member) => !!member.vaccinatedAt)
        .length,
      membersCount: family.members.length,
    } as Family
  })

export const getFamilyMember = (id: number) => families.find((m) => m.id === id)
